var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvatarRed = function SvgAvatarRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D73847",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7465 19.0914C30.6676 19.0804 30.5888 19.0804 30.5099 19.0914C28.7636 19.0364 27.3778 17.6407 27.3778 15.9262C27.3778 14.1787 28.8312 12.75 30.6338 12.75C32.4252 12.75 33.8898 14.1677 33.8898 15.9262C33.8786 17.6407 32.4928 19.0364 30.7465 19.0914Z",
    fill: "#D73847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 26.7076C33.1571 27.5318 31.3882 27.8396 29.7546 27.6307C30.1827 26.7295 30.408 25.7294 30.4193 24.6744C30.4193 23.5753 30.1715 22.5313 29.6983 21.6191C31.3657 21.3993 33.1345 21.707 34.4076 22.5313C36.1878 23.6742 36.1878 25.5536 34.4189 26.7076Z",
    fill: "#D73847"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2521 19.0914C18.331 19.0804 18.4099 19.0804 18.4887 19.0914C20.235 19.0364 21.6208 17.6407 21.6208 15.9262C21.6208 14.1677 20.1674 12.75 18.3648 12.75C16.5734 12.75 15.1201 14.1677 15.1201 15.9262C15.1201 17.6407 16.5058 19.0364 18.2521 19.0914Z",
    fill: "#D73847"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.376 24.6746C18.376 25.7406 18.6126 26.7517 19.0407 27.6639C17.4522 27.8288 15.796 27.4991 14.5792 26.7188C12.7991 25.5648 12.7991 23.6854 14.5792 22.5315C15.7847 21.7402 17.486 21.4214 19.0858 21.5973C18.6239 22.5205 18.376 23.5645 18.376 24.6746Z",
    fill: "#D73847"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6511 27.9935C24.561 27.9825 24.4596 27.9825 24.3582 27.9935C22.2851 27.9276 20.629 26.268 20.629 24.2239C20.6402 22.1357 22.364 20.4432 24.5159 20.4432C26.6565 20.4432 28.3916 22.1357 28.3916 24.2239C28.3803 26.268 26.7354 27.9276 24.6511 27.9935Z",
    fill: "#D73847"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9895 30.2687C19.2883 31.3787 19.2883 33.2031 20.9895 34.3021C22.9273 35.566 26.1045 35.566 28.0423 34.3021C29.7435 33.1921 29.7435 31.3677 28.0423 30.2687C26.1157 29.0048 22.9386 29.0048 20.9895 30.2687Z",
    fill: "#D73847"
  })));
};
export default SvgAvatarRed;